export default "__VITE_ASSET__COEFeYv___"